// InfiniteImageCarousel.jsx
import React from "react";
import { Box, Image } from "@mantine/core";
import './InfiniteImageScrollCarouselStyle.css';


export function InfiniteImageCarousel(
    { images, reverseSlide, slideWidth = 240, gap = 60 } : 
    { images: any; reverseSlide : boolean, slideWidth?: number; gap?: number }) {
  // `images` should be an array of image URLs
  const doubledImages = [...images, ...images]; // duplicate for seamless loop

    const trackStyle = (reverseSlide == false) ?
        {
            "--slide-width": `${slideWidth}px`,
            "--slide-gap": `${gap}px`,
        }
    :
        {
            animationDirection: 'reverse',
            "--slide-width": `${slideWidth}px`,
            "--slide-gap": `${gap}px`,
        }

  return (
    <Box className="infinite-carousel">
      <Box
        className="infinite-carousel__track"
        // CSS vars for width / spacing if you want to tweak via JS
        style={
            trackStyle
        }
      >
        {doubledImages.map((src, idx) => (
          <Box pb={'1em'} style={{border: '1px sold black'}} className="infinite-carousel__slide" key={idx}>
            <Image p={'1em'} src={src} alt={`Carousel item ${idx % images.length}`} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
